// extracted by mini-css-extract-plugin
module.exports = {"consentIcon":"consentsSubForm_consentIcon__2SNht"};